// The kiosk dashboard (docs/architecture.md §11.6): the same build, read-only. On the kiosk host (maillonfroid.online,
// VITE_KIOSK_HOST in other builds) every signed-in user gets it, whatever their role; a browser signed in with a kiosk
// link gets it on any host. On localhost, ?kiosk=1 switches it on for the tab (and ?kiosk=0 off), to try it.

const KIOSK_HOST = import.meta.env.VITE_KIOSK_HOST ?? 'maillonfroid.online';
const DEV_FLAG = 'cck.kiosk';

function devFlag(): boolean {
  if (location.hostname !== 'localhost') return false;
  try {
    const q = new URLSearchParams(location.search).get('kiosk');
    if (q !== null) sessionStorage.setItem(DEV_FLAG, q === '1' ? '1' : '');
    return sessionStorage.getItem(DEV_FLAG) === '1';
  } catch {
    return false;
  }
}

export const kioskHost: boolean = location.hostname === KIOSK_HOST || devFlag();

/** The organisation pages a read-only dashboard shows (the rest redirect to the overview). */
export const READ_ONLY_PAGES = /^\/o\/[^/]+(?:\/(?:assets|alarms|haccp|energy|exports)(?:\/.*)?)?\/?$/;

/** How often a read-only dashboard refreshes its data: kiosks have no live connection. */
export const KIOSK_REFRESH_MS = 30_000;
